module.exports = __webpack_public_path__ + "img/ryd_eng.a71398d0.svg";